import React from 'react';
import { AppBar as MuiAppBar, Toolbar, Typography, Box } from '@mui/material';

function AppBar() {
  return (
    <MuiAppBar position="static">
      <Toolbar>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <img 
            src="https://www.toread.com.cn/Public/Home/img/brand.png" 
            alt="Logo" 
            style={{ height: '40px', marginRight: '10px' }} 
          />
          <Typography variant="h6" component="div">
            探路者 AI 图像识别演示
          </Typography>
        </Box>
      </Toolbar>
    </MuiAppBar>
  );
}

export default AppBar;
